import m from 'mithril'
import BaseView from './BaseView'
import { deepFreeze, removeFalsyValues } from '../../utils/object'

const CLASS_NAMES = {
  VISITED: 'visited',
}

const TAG_NAMES = {
  INPUT: 'input',
  TEXTAREA: 'textarea',
  SELECT: 'select',
}

const { TEXTAREA, SELECT, INPUT } = TAG_NAMES

const INPUT_TYPES = {
  TEXT: 'text',
  HIDDEN: 'hidden',
  CHECKBOX: 'checkbox',
  EMAIL: 'email',
  RADIO: 'radio',
}

const { TEXT, HIDDEN, CHECKBOX } = INPUT_TYPES

const DEFAULTS = deepFreeze({
  tagName: INPUT,
  type: TEXT,
  onclick: null,
  onchange: null,
  config: null,
  classList: [],
  autofocus: false,
  title: null,
  children: null,
  siblings: null,
  isDisabled: false,
  isReadonly: false,
  isRequired: false,
  placeholder: null,
  maxlength: null,
  minlength: null,
  style: null,
  name: null,
  value: null,
  pattern: null,
  id: null,
  spellcheck: null,
  misvalidationMessage: null,
})

export { CLASS_NAMES, TAG_NAMES, INPUT_TYPES, DEFAULTS }

function bindCallerView(fn) {
  return (fn instanceof Function && fn.bind(this)) || undefined
}

export default class InputView extends BaseView {
  get DEFAULTS() {
    return DEFAULTS
  }

  view(ctrl) {
    let {
      tagName,
      id,
      type,
      classList,
      title,
      autofocus,
      isDisabled,
      isReadonly,
      isRequired,
      value,
      pattern,
      placeholder,
      minlength,
      maxlength,
      name, //spellcheck,
      immutableAttrs,
      style,
      onclick,
      onchange,
      config,
      children,
      siblings,
      misvalidationMessage,
    } = this
    onclick = bindCallerView(onclick)
    config = bindCallerView(config)
    // Values of these attributes may be dynamic and may contain strings, which may be interpreted as selectors.
    let attrs = {
      onclick,
      onchange,
      config,
      name,
      pattern,
      value,
      disabled: isDisabled,
      readonly: isReadonly,
    }
    // Values of these attributes aren't expected to change.
    Object.assign(immutableAttrs, {
      required: isRequired,
      placeholder,
      // FIXME: this doesn't work because BaseView doesn't compare value with the DEFAULTS.
      // spellcheck: [undefined, null, ].includes(spellcheck) ? false : spellcheck.toString(),
      minlength,
      maxlength,
      autofocus,
      title,
      style,
      type: tagName === INPUT ? type : null,
      id,
    })
    let classes = classList.join('.')
    let inputView = m(`${tagName}${immutableAttrs}.${classes}`, removeFalsyValues(attrs), children)
    let currentView = [inputView]
    if (siblings) {
      currentView = currentView.concat(siblings)
    }
    if (misvalidationMessage) {
      currentView.push(m('.misvalidation-message', misvalidationMessage))
    }
    return currentView
  }
}

function optionTag(text, props = { value: '', isSelected: false }) {
  let { value, isSelected: selected } = props
  return m('option', { value, selected }, text)
}

function inheritedInput(...opts) {
  return InputView.create(Object.assign({}, ...opts)).view()
}

let select = inheritedInput.part({ tagName: SELECT })
let checkbox = inheritedInput.part({ type: CHECKBOX })
let hiddenInput = inheritedInput.part({ type: HIDDEN })
let textarea = inheritedInput.part({ tagName: TEXTAREA })
let requiredInput = inheritedInput.part({ isRequired: true })

export { hiddenInput, requiredInput, textarea, select, optionTag, checkbox }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/InputView.js